import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Tooltip from "@mui/material/Tooltip";
import ErrorOutlineOutlined from "@mui/icons-material/ErrorOutlineOutlined";
import { useTheme } from "@mui/material/styles";
import type { AutocompleteRenderInputParams } from "@mui/material/Autocomplete";

interface Props {
  isError: boolean;
  errorMessage: string;
  params: AutocompleteRenderInputParams;
}

const AutoCompleteTextField = ({ isError, errorMessage, params }: Props) => {
  const theme = useTheme();

  return (
    <Box sx={{ display: "flex", alignItems: "center" }}>
      <TextField
        autoComplete="chrome-off"
        variant="standard"
        {...params}
        error={isError}
        sx={{
          flex: 1,
          minWidth: 0,
          m: theme.spacing(1, 0.5, 1.5),
          "& .MuiInput-root": {
            fontSize: 14,
            height: 21,
            width: "100%",
          },
          "& .MuiInput-underline": {
            borderBottom: 1.5,
            borderBottomColor: isError
              ? theme.palette.redAlert.main
              : `${theme.palette.primary.main} !important`,
          },
          "& .MuiInput-underline:focus-within": {
            borderBottomColor: isError
              ? theme.palette.redAlert.main
              : theme.palette.primary.main,
          },
          "& .MuiInput-root:hover:not(.Mui-disabled):before": {
            borderBottom: "none",
          },
          "& .MuiInput-root:before": {
            borderBottom: 0,
          },
          "& .MuiInputBase-input": {
            fontSize: 14,
            padding: 0,
          },
          "& .MuiInput-underline:after": {
            borderBottom: 0,
          },
          "input[type='time']::-webkit-calendar-picker-indicator": {
            display: "none",
          },
        }}
      />
      {isError && (
        <Tooltip
          title={
            <Box
              sx={{
                backgroundColor: theme.palette.primary.main,
                color: theme.palette.white.main,
                fontSize: 14,
              }}
            >
              {errorMessage}
            </Box>
          }
        >
          <Box
            component="span"
            role="button"
            tabIndex={0}
            sx={{
              display: "flex",
              alignItems: "center",
              cursor: "pointer",
              color: theme.palette.redAlert.main,
              flexShrink: 0,
            }}
          >
            <ErrorOutlineOutlined sx={{ fontSize: 16 }} />
          </Box>
        </Tooltip>
      )}
    </Box>
  );
};

export default AutoCompleteTextField;
